import { withStyles, Drawer, withTheme } from "@material-ui/core";
import styles from "./styles";
import { compose } from "recompose";

const DispatchDrawer = ({
  classes,
  open,
  anchor,
  variant,
  theme,
  BackdropProps,
  drawerClasses,
  children,
}) => {
  return (
    <Drawer
      variant={variant ?? "temporary"}
      role="dialog"
      anchor={anchor ?? "right"}
      open={open}
      classes={drawerClasses ?? {
        paper: `${classes.paperAnchor} ${classes.drawerPaper} ${
          !open ? classes.paperHidden : ""
        }`,
        modal: `${classes.modal} ${theme.themeName}Theme`,
        paperAnchorRight: classes.applyDrawerShadow,
      }}
      BackdropProps={BackdropProps ?? {
        className: classes.nonTransparentBackdrop,
      }}
    >
      {children}
    </Drawer>
  );
};

export default compose(withStyles(styles), withTheme())(DispatchDrawer);
